import Upload_File_Service from 'services/account/uploadFile';

export const handleUploadTextFile = (filesToUpload, tinyMCE, fileUploader) => {
  tinyMCE.editorManager.activeEditor.setProgressState(true);
  Upload_File_Service(filesToUpload).then((res) => {
    const location = res.data.aws_url;
    const file_name = res.data.name;
    const fr = new FileReader();
    fr.onload = () => {
      tinyMCE.insertContent(`
         <div class="mceNonEditable" style="background-color:#dfe8f2; padding:5px; padding-right:25px; display:table">
      <img src="/static/online_roundtable_icons/attach_file_icon.svg" alt=""  />
      <a class="mceNonEditable" style="text-decoration: none" href="${location}" target="_blank">
        <span class="mceNonEditable" style="color:#3B24E3; font-size:18px; font-weight:bold" >${file_name}</button>
      </a>
      </div>`);
      tinyMCE.editorManager.activeEditor.setProgressState(false);
      fileUploader.val('');
    };
    fr.readAsDataURL(filesToUpload[0]);
  });
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Utils/UploadTextFile.js